import { Documents } from '@features/Contractor/Documents/Documents'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate/useTranslations'

const RouteComponent: React.FC = () => {
  const { contractorId } = Route.useParams()
  return <Documents contractorId={contractorId} />
}

export const Route = createFileRoute('/contractor/$contractorId/documents')({
  component: RouteComponent,
  staticData: {
    breadcrumb: t('contractor-documents.breadcrumb'),
  },
})
